import i18nFactory, { i18nRaw as i18nRawFactory } from '@yandex-int/i18n';
import * as React from 'react';

import { mapStringToCurrencySymbol } from '../../mappers/common/common';
import { Bem } from '../../service/Bem/Bem';
import { CurrencyCode } from '../../typings/graphql-grid';
import { MoneyText } from '../MoneyText/MoneyText';

import './FreelancerServicePriceTag.css';
import * as keyset from './FreelancerServicePriceTag.i18n';

const i18n = i18nFactory(keyset);
const i18nRaw = i18nRawFactory(keyset);

export enum FreelancerServicePriceThemes {
    SMALL = 'small',
    BIG = 'big'
}

export interface FreelancerServicePriceTagProps {
    workCurrency: CurrencyCode;
    approximatePrice?: number;
    approximateDuration?: string;
    theme: FreelancerServicePriceThemes;
}

const BLOCK = 'freelancer-service-price-tag';

export class FreelancerServicePriceTag extends React.PureComponent<
    FreelancerServicePriceTagProps
> {
    render() {
        const {
            theme,
            approximatePrice,
            approximateDuration,
            workCurrency
        } = this.props;

        const approxPrice = (
            <MoneyText
                num={approximatePrice}
                fractionalPartLength={0}
                currency={mapStringToCurrencySymbol(workCurrency)}
                key={approximatePrice}
            />
        );

        return (
            <div className={Bem.cls({ block: BLOCK, mods: { theme } })}>
                {approximatePrice !== undefined && (
                    <p>
                        {i18nRaw('approx-price-lower-boundary-label', {
                            approxPrice
                        })}
                    </p>
                )}
                {approximateDuration && (
                    <p
                        className={
                            approximatePrice !== undefined
                                ? Bem.cls({
                                      block: BLOCK,
                                      elem: 'duration-tag',
                                      mods: { theme }
                                  })
                                : ''
                        }
                    >
                        {approximateDuration}
                    </p>
                )}
                {theme === FreelancerServicePriceThemes.BIG && (
                    <div className={Bem.cls(BLOCK, 'info')}>
                        {i18n('info-line')}
                    </div>
                )}
            </div>
        );
    }
}
